import { PLUGIN } from "src/app/common/enums/plugins";
import { SLOT } from "src/app/common/enums/slot";
import { TabConfig } from "src/app/shared/ui/tabs/tabs.component";
import { TableColumnConfig } from "src/app/slots/three-year-plan/common/components/table/table.interfaces";
import { LogModules } from "./configuration-area-downloads.service";

export type ExtendedTabConfig = TabConfig<LogModules> & { showFor: Array<"logs" | "reports"> };

export const DOWNLOAD_TABS: Array<TabConfig<LogModules> & { showFor: Array<"logs" | "reports"> }> = [
  {
    name: SLOT.THREE_YEAR_PLAN,
    label: `LAUNCHPAD.MODULES.${SLOT.THREE_YEAR_PLAN}.name`,
    showFor: ["logs", "reports"]
  },
  {
    name: SLOT.OUTAGE_MONITORING,
    label: `LAUNCHPAD.MODULES.${SLOT.OUTAGE_MONITORING}.name`,
    showFor: ["logs"]
  },
  {
    name: SLOT.ACCOUNTING,
    label: `LAUNCHPAD.MODULES.${SLOT.ACCOUNTING}.name`,
    showFor: ["logs", "reports"]
  },
  {
    name: PLUGIN.STREET_LIGHTING,
    label: `LAUNCHPAD.PLUGINS.${PLUGIN.STREET_LIGHTING}.name`,
    showFor: ["logs"]
  },
  {
    name: PLUGIN.KWP,
    label: `LAUNCHPAD.PLUGINS.${PLUGIN.KWP}.name`,
    showFor: ["logs"]
  },
  {
    name: "overall",
    label: `CONFIGURATION_AREA.TABS.CROSS_MODULE`,
    showFor: ["reports"]
  }
];

export const configurationAreaDownloadsColumnConfig: Array<TableColumnConfig> = [
  {
    id: "timestamp",
    key: "Zeitstempel Erzeugung",
    type: "date",
    dateFormat: "EEEE, dd.MM.yyyy, HH:mm",
    style: {
      width: "30%"
    }
  },
  {
    id: "fileName",
    key: "Dateiname",
    type: "text"
  },
  {
    id: "size",
    key: "Dateigröße",
    type: "text",
    style: {
      width: "100px"
    }
  },
  {
    id: "download",
    key: "",
    type: "action",
    actionIcon: "ec_download",
    style: {
      width: "50px"
    }
  }
];
